"use client";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getAllJobsApplication } from "../../../services/jobsServices";
import DropdownSelect from "../../../components/admin/common/DropDownSelect";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import Pagination from "../../../components/admin/common/Pagination";
import JobApplied from "../../../components/admin/jobs/JobApplied";

const AppliedJobs = () => {
  const params = new URLSearchParams(window.location.search);
  const jobId = params.get("jobId");
  const jobTitle = params.get("title");

  const [entriesOption, setEntriesOption] = useState({
    value: 10,
    label: "10",
  });
  const [lastIds, setLastIds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [jobsList, setJobsList] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  const currentLastId =
    currentIndex > 0 ? lastIds[currentIndex - 1] : undefined;

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["jobs", currentLastId, entriesOption.value],
    queryFn: () =>
      getAllJobsApplication({
        lastId: currentLastId,
        limit: entriesOption.value,
        jobId: jobId,
      }),
    keepPreviousData: true,
  });

  useEffect(() => {
    if (data?.data?.items?.length >= 0) {
      setJobsList(data.data.items);
      setHasMore(data.data.hasMore);
    }
  }, [data]);

  const handleNext = () => {
    if (hasMore && data?.data?.nextCursor) {
      const updated = [...lastIds];
      updated[currentIndex] = data.data.nextCursor;
      setLastIds(updated);
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleEntriesChange = (option) => {
    setEntriesOption(option);
    setCurrentIndex(0);
    setLastIds([]);
  };

  const handleGoBack = () => {
    window.location.href = "/admin/jobs/list";
  };

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <Sidebar />
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            {/* Job Title Header with Back Button */}
            <div className="p-4 pb-2">
              <div className="flex items-start gap-3 ">
                <button
                  onClick={handleGoBack}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-sm hover:shadow-md transition-shadow"
                  title="Go back"
                >
                  <span className="text-gray-600 text-lg">←</span>
                </button>
                <div>
                  <h1 className="text-xl font-bold text-gray-800">
                    {jobTitle
                      ? `Applications for : ${jobTitle}`
                      : "Job Applications"}
                  </h1>
                  <p className="text-sm text-gray-600">
                    Manage and review job applications
                  </p>
                </div>
              </div>
            </div>

            <div className="flex-1 px-4 pb-4 overflow-y-auto">
              <DropdownSelect
                selected={entriesOption}
                onChange={handleEntriesChange}
              />

              {isLoading ? (
                <p>Loading jobs...</p>
              ) : isError ? (
                <p>Error fetching jobs</p>
              ) : (
                <>
                  <JobApplied
                    applications={jobsList}
                    refetch={refetch}
                    startIndex={currentIndex * entriesOption.value}
                  />
                  <Pagination
                    currentPage={currentIndex + 1}
                    hasMore={hasMore}
                    onPrevious={handlePrevious}
                    onNext={handleNext}
                  />
                </>
              )}
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default AppliedJobs;
